import React from 'react';

import { type JVSIcons } from '@mairistem/composants';
import { Icon } from '@mairistem/finances-utils';
import { Sens, type Mouvement } from '@mairistem/comptabilite';

const getMouvementIcon = (mouvement: Mouvement) => {
  let iconName: JVSIcons = 'File';

  if (mouvement.datePcePec) {
    iconName = 'FileCheck2';
  } if (mouvement.datePceInst && !mouvement.datePceRej && !mouvement.datePcePec) {
    iconName = 'FileClock';
  } if (mouvement.datePceRej && !mouvement.datePcePec) {
    iconName = 'FileX2';
  }

  return (
    <Icon
      iconSet="Lucide"
      name={iconName}
      color={mouvement.sens === Sens.DEPENSE ? '#7a3030' : '#476d4e'}
    />
  );
};

export default getMouvementIcon;
